<script>
  import { Pie, mixins } from 'vue-chartjs'

  export default {
    extends: Pie,
    mixins: [mixins.reactiveProp],
    props:['chartData', 'color', 'titulo'],

    mounted () {
      this.addPlugin({
        afterInit(c){

          var ancho = c.chart.width;
          if(ancho <= 200){
            var a = 90;
            var largo = Math.max(...(c.tooltip._data.labels.map(el => el.length)))
            c.legend.options.labels.fontSize = a / largo ;

            if(c.legend.options.labels.fontSize < 6){
                c.legend.options.labels.fontSize = 6;
            }
          }
          if(ancho > 90){
            if(c.legend.options.labels.fontSize < 9){
                c.legend.options.labels.fontSize = 9;
            }
          }
          c.options.legend.labels.boxWidth = c.legend.options.labels.fontSize;
          
        }
      });
      this.renderChart(this.chartData, {
        responsive: true, 
        maintainAspectRatio: false, 
        legend:{
          labels:{
            fontColor: (this.color) ? 'white' : 'black',
            fontSize: 16,
            fontFamily:'Myriad'
          },
          position: 'bottom'
        }, 
        tooltips:{
          enabled: false,
          // callbacks: {
          //   label : function(tooltipItem, data){
          //     let rubro = data.labels[tooltipItem.index];

          //     return rubro;
          //   }
          // }
        },
        title:{
          display: true,
          text: this.titulo,
          fontColor: (this.color) ? 'white' : 'black',
          fontSize: 16,
          fontFamily:'Myriad'
        },
        animation:{
          duration: 0
        },
        onClick: this.enviarTabla
      });
    },
    methods:{
      enviarTabla(p, e){
        var parametros = {
          rubroId : (this.chartData.datasets[0].rubroId > 0) ? this.chartData.datasets[0].rubroId : this.chartData.datasets[0].rubros[e[0]._index],
          areaId : ((this.chartData.datasets[0].areaId > 0) || 
                    (this.chartData.datasets[0].rubroId <= 0 && this.chartData.datasets[0].areaId)) ? this.chartData.datasets[0].areaId : this.chartData.datasets[0].areas[e[0]._index]
        }
        this.$emit('crearTabla', true, parametros)
      }
    }

  }

</script>


// WEBPACK FOOTER //
// src/components/SIVAC/Reportes/Graficas/Pastel.vue